<template>
  <div id="mainBlockSelector">
    <div class="contentBox" v-if="!isBlockSelector">
      <div>
        <h3>Выберите условия займа</h3>
         <instSelect
          :fieldName="'CALC_SUMM'"
         ></instSelect>
        <div class="slWrap" >
          <range-slider
              class="slider"
              :min="0"
              :max="getActiveDistinctAmount.length - 1"
              :step="1"
              v-model="rangeValueSumm">
          </range-slider>
          <div class="fromTo">
            <p class="pa">от {{getActiveMinDeal | moneyFormat}} ₽</p>
            <p class="pb">до {{getActiveMaxDeal | moneyFormat}} ₽</p>
          </div>
        </div>
         <instSelect
          :fieldName="'CALC_WEEK'"
         ></instSelect>
        <div class="slWrap">
          <range-slider
              class="slider"
              :min="0"
              :max="getActiveDistinctPeriod.length - 1"
              :step="1"
              v-model="rangeValuePeriod">
          </range-slider>
          <div class="flex mPositions">
            <p
                v-for="(item,index) in getActiveDistinctPeriod"
                v-bind:key="index"
                class="descTxt"
            >
              <span v-html="insertBr(item.name)"></span>
            </p>
          </div>
        </div>
      </div>
      <productInfo></productInfo>
    </div>
    <button class="instButton" v-on:click="navigationEmit('zform', $event)" v-if="!isBlockSelector">Получить деньги</button>
  </div>
</template>

<script>
  import {mapState,mapGetters} from 'vuex'
  import RangeSlider from 'vue-range-slider'
  import 'vue-range-slider/dist/vue-range-slider.css'
  export default {
    name: "uiProductAmountSelector",
    props:{
      currentScreen:{
        type:String,
        default:'',
      },
      showButton:{
        type:Boolean,
        default: true
      }
    },
    components: {
      RangeSlider,
      instSelect: () => import('@/components/inst/instSelect.vue'),
      productInfo: () => import('@/components/pdl/amountSelectProuctInfo.vue'),
    },
    data(){
      return{
        ttt:0
      }
    },
    methods:{

        insertBr(value){
          if (!value) return '';
          return  value.split(' ').join('<br>');
        },
      navigationEmit(id, $event) {

        this.$emit('scrollingTo', {
          id:id,
          event:$event
        })
      },

    },
    computed:{
      ...mapGetters([
        'getSelectedDeal',
        'getActiveDistinctAmount',
        'getActiveMinDeal',
        'getActiveMaxDeal',
        'getActiveDistinctPeriod',
        'getActiveCalcSummIndex',
        'getActiveCalcWeekIndex'
      ]),
      ...mapState({
        valueVuex: state => state.Form.sendData,
      }),
      isOnline() {
        return this.getSelectedDeal.vwIsPdl === '1';
      },
      rangeValueSumm:{
        get(){
          return this.getActiveCalcSummIndex;
        },
        set(value){
          this.$store.dispatch('saveSendData', {
            target: 'CALC_SUMM',
            value: this.getActiveDistinctAmount[value].value
          });

        }
      },
      rangeValuePeriod:{
        get(){
          return this.getActiveCalcWeekIndex;
        },
        set(value){
          this.$store.dispatch('saveSendData', {
            target: 'CALC_WEEK',
            value: this.getActiveDistinctPeriod[value].value
          });

        }
      },
      isBlockSelector(){
        return  this.currentScreen != 'fio';
      },
      tmpSaleCalc(){
        let out = 0;
        if(this.getSelectedDeal.SaleForVirgin) {
          if(this.getSelectedDeal.Amount <= 5000 && this.getSelectedDeal.loanPeriod <= 14) {
            out = this.getSelectedDeal.Amount;
          }
        }
        return out;
      }
    },
    watch:{

    },
    mounted(){


    }
  }
</script>

<style scoped>
#mainBlockSelector{font-family: 'Roboto';}


.contentBox { width: 100%;background-color: white;border-radius: var(--font-size-20);}
.contentBox > div:first-child{padding: var(--font-size-30) var(--font-size-49) var(--font-size-39);}
.contentBox > div > h3 {  font-size: var(--font-size-24); font-weight: 700; text-align: center; margin-bottom: var(--font-size-20); }

/deep/.slider { width: 100%;  padding: 0; }
/deep/.slider .range-slider-hidden { display: none; }
/deep/.slider .range-slider-rail { background-color: var(--color-green); }
/deep/.slider .range-slider-fill { background-color: var(--color-dark-green); }
/deep/.slider .range-slider-fill, .slider .range-slider-rail{height: var(--font-size-06);border-radius: var(--font-size-06);}
/deep/.slider .range-slider-knob{width: var(--font-size-30);height:var(--font-size-30);border-radius: var(--font-size-30);border:var(--font-size-04) solid var(--color-dark-green); background: var(--color-dark-green);box-shadow: inset 0 0 0 var(--font-size-04) white;}



.fromTo{display: flex;align-items: center;justify-content: space-between;font-size: var(--font-size-16);font-weight: 500;margin: var(--font-size-16) 0;color: var(--color-gray-type3);}


.mPositions{margin-left:calc(-1 * 100% / 6/ 2); width: calc(100% + (100% / 6));display: flex;justify-content: space-between;margin-top: var(--font-size-16);}
.descTxt{display: flex;align-items: center;text-align: center;width: calc(100% / 6)}
.descTxt span{width: 100%;color: var(--color-gray-type3);}


.greenBorder { background-color: var(--color-dark-green); width: 100vw; border-radius: 10px; padding: 10vw 0; border-radius: var(--font-size-20);}
.greenBorder > div {background-color: white;}

.instButton{margin: var(--font-size-20) auto;}


@media screen and (min-width: 760px) {
 #mainBlockSelector {width: var(--font-size-420);}
 
}


@media screen and (min-width: 1170px) {

}


/* 

#mainBlockSelector > button { border-radius: 4.27vw; margin: 0 auto 12.65vw auto; width: 88.24vw }
.slWrap > p { text-align: center; text-transform: lowercase }
.slWrap > p > b { text-align: center; padding: 0 1.33vw }
.slider { width: 100%; box-sizing: border-box; padding: 0; margin-bottom: 2.94vw  }
.fromTo { display: flex; padding: 0 6.93vw; justify-content: space-between; }
.fromTo > p { margin-bottom: 4.41vw; font-size: 2.94vw }
.flex { display: flex; justify-content: space-between }


.disable{pointer-events: none}
.onOffLine { display: flex; justify-content: space-between }
.onOfflineLabel { height: 7.35vw; width: 25.59vw; color: #FFFFFF; display: flex; align-items: center; justify-content: center; font-size: 4.71vw }
.greenBorder { background-color: #0D5740; width: 100vw; border-radius: 10px; padding: 10vw 0; }
.greenBorder > div { background-color: #fff;width: 81.18vw; border-radius: 10px; padding: 3.53vw 4.71vw 5.29vw 4.71vw; margin: 0 auto}
.greenBorder > div > .onOffLine > h2 {  margin-bottom: 2.94vw; font-size: 5.59vw }
.greenBorder > div > div > div { display: flex; justify-content: space-between; padding-top: 2.97vw; ; color: #45B537 }

.greenBorder > div > div > div > .blackText { color: black }
.greenBorder > div > div > .border { color: #45B537; border-top: 1px solid #0C5A44; padding-top: 6.47vw }
.greenBorder > div > div > div > .round { padding: 0 1.47vw;height: 5.88vw; border-radius: 2.35vw; background: #45B537; color: #FFFFFF; display: flex; align-items: center; justify-content: center; }
.purpleBorder { background-color: #0D5740; width: 100vw; border-radius: 10px; padding: 10vw 0;  }
.purpleBorder > div { background-color: #fff;width: 81.18vw; border-radius: 10px; padding: 3.53vw 4.71vw 5.29vw 4.71vw; margin: 0 auto}
.purpleBorder > div > .onOffLine > h2 {  margin-bottom: 2.94vw; font-size: 5.59vw }
.purpleBorder > div > div > div { display: flex; justify-content: space-between; padding-top: 2.97vw; color: #0D5740 }

.purpleBorder > div > div > div > .blackText { color: black }
.purpleBorder > div > div > .border { color: #0D5740; border-top: 1px solid #0C5A44; padding-top: 6.47vw }
.purpleBorder > div > div > div > .round { padding: 0 1.47vw;height: 5.88vw; border-radius: 2.35vw; background: #0D5740; color: #FFFFFF; display: flex; align-items: center; justify-content: center; }

.nextStepBlock { display: flex; align-items: center; }
.nextStepBlock > p { display: flex; align-items: center; }
.nextStepBlock > button { border-radius: 2.67vw; width: 56vw; padding: 4.27vw; height: 12.27vw}
.bgRevers{background: #45B537;color:white;padding: 1vw;border-radius: 6px;}
.descTxt{display: flex;align-items: center;text-align: center;width: calc(100% / 6)}
.descTxt span{width: 100%;}
.mPositions{margin-left:calc(-1 * 100% / 6/ 2); width: calc(100% + (100% / 6));}

@media (min-width: 760px) {
  span { font-size: 0.97vw }
  .contentBox { width: 33.87vw; border-radius: 10px; padding: 3.23vw 3.23vw 0; margin-bottom: 4.44vw;
    background: #FFF; }
  .contentBox > div { padding: 2.10vw 0 }
  .contentBox > div:first-child { padding: 0 ;width: 100%;}
  .contentBox > div > h3 { margin-bottom: 2.58vw; padding: 0; font-size: 1.45vw }

  /deep/ .slider { margin-bottom: 0.97vw }
  /deep/ .slider > .range-slider-inner > .range-slider-knob { border: 0.17vw solid #0D5740; background-color: #0D5740; box-shadow: inset 0 0 0 0.13rem white; width: 1.37vw; height: 1.37vw; }
  /deep/ .slider > .range-slider-inner > .range-slider-rail { height: 2px }
  /deep/ .slider > .range-slider-inner > .range-slider-fill { height: 2px }

  .fromTo > p { font-size: 0.97vw; margin-bottom: 1.61vw }

  .onOfflineLabel { height: 2.02vw; width: 7.02vw; font-size: 1.29vw }
  .greenBorder { width: 33.87vw}
  .greenBorder > div { width: 26.69vw; padding: 1.21vw 1.53vw}
  .greenBorder > div > .onOffLine > h2 { margin-bottom: 0.97vw; font-size: 1.94vw }
  .greenBorder > div > div > .border { padding-top: 2.26vw }
  .greenBorder > div > div > div { padding-top: 1.13vw }

  .greenBorder > div > div > div > .round {  height: 2.02vw; border-radius: 10px; padding: 0 0.97vw }
  .purpleBorder { width: 33.87vw}
  .purpleBorder > div { width: 26.69vw; padding: 1.21vw 1.53vw}
  .purpleBorder > div > .onOffLine > h2 { margin-bottom: 0.97vw; font-size: 1.94vw }
  .purpleBorder > div > div > .border { padding-top: 2.26vw }
  .purpleBorder > div > div > div { padding-top: 1.13vw }
 
  .purpleBorder > div > div > div > .round {  height: 2.02vw; border-radius: 10px; padding: 0 0.97vw }
  #mainBlockSelector { background: none ;}
  #mainBlockSelector > button { border-radius: 15px; width: 28.23vw; margin-bottom: 0.65vw }
  .fromTo { margin-bottom: 1.45vw; padding: 0 }
  .flex { margin-bottom: 1.21vw }
  .nextStepBlock { display: flex; align-items: center; justify-content: flex-end; margin-bottom: 4.27vw }
  .nextStepBlock > p { display: flex; align-items: center; }
  .nextStepBlock > button { border-radius: 10px; width: 16.13vw; padding: 1.29vw 2.10vw; height: 4.03vw; margin: 0 0 0 1.94vw }
  .bgRevers{padding: 0.4vw;}
  }
@media (min-width: 1240px) {
  span { font-size: 12px }

  .contentBox { width: 420px; border-radius: 10px; padding: 40px 38px 0; margin-bottom: 55px; background: #FFF; }
  .contentBox > div { padding: 26px 0 }
  .contentBox > div:first-child { padding: 0 }
  .contentBox > div > h3 { margin-bottom: 32px; padding: 0; font-size: 18px }


  .slWrap > p { opacity: 0.4 }
  .fromTo > p { opacity: 0.4; font-size: 12px }
  .flex > p { opacity: 0.4 }
  .onOfflineLabel { height: 25px; width: 87px; font-size: 16px }
  .greenBorder { width: 420px }
  .greenBorder > div { width: 331px; padding: 15px 19px}
  .greenBorder > div > .onOffLine > h2 { margin-bottom: 12px; font-size: 24px }
  .greenBorder > div > div > .border { padding-top: 28px }
  .greenBorder > div > div > div { padding-top: 14px }

  .greenBorder > div > div > div > .round {  height: 25px; border-radius: 10px; padding: 0 12px }
  .purpleBorder { width: 420px }
  .purpleBorder > div { width: 331px; padding: 15px 19px}
  .purpleBorder > div > .onOffLine > h2 { margin-bottom: 12px; font-size: 24px }
  .purpleBorder > div > div > .border { padding-top: 28px }
  .purpleBorder > div > div > div { padding-top: 14px }

  .purpleBorder > div > div > div > .round {  height: 25px; border-radius: 10px; padding: 0 12px }

  #mainBlockSelector > button { width: 350px; margin-bottom: 8px }
  .fromTo { margin-bottom: 18px; padding: 0 }
  .flex { margin-bottom: 1.21vw }
  .nextStepBlock { margin-bottom: 4.27vw }

  .nextStepBlock > button { border-radius: 10px; width: 16.13vw; padding: 1.29vw 2.10vw; height: 4.03vw; margin: 0 0 0 1.94vw }
  .bgRevers{padding: 4px;}
} */


</style>
